<template>
  <el-dialog
    title="审核图片"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
    top="2%"
  >
    <div
      class="flex p16 justify-between gap-16"
      v-loading.fullscreen.lock="loading"
      style="height: 500px"
    >
      <el-image
        style="width: 500px"
        class="w49f"
        :src="data.imgSrc"
        :preview-src-list="[data.imgSrc]"
      >
      </el-image>
      <div class="w49f t-left overflow-auto">
        <div
          v-for="(item, index) in data.suspectInfo?.afterSuspectType"
          :key="index"
          class="mb15"
        >
          <div
            class="flex justify-between items-center p-8"
            :style="isReportMap[isReportEnum.N]?.style"
          >
            <div class="flex">
              <div
                :style="isReportMap[isReportEnum.N]?.bageStyle"
                class="text-bage mr5"
              >
                {{ index + 1 }}
              </div>
              <div>
                <span v-if="[1].includes(data.activeTab)">
                  {{
                    $getNameByKey(item, "图像识别不合规场景-待审核")
                  }}
                </span>
                <span v-if="[3, 4].includes(data.activeTab)">
                  {{
                    $getNameByKey(item, "图像识别不合规场景-已审核")
                  }}
                </span>
              </div>
            </div>
            <!-- <el-button
              v-if="data.suspectInfo.isReport === isReportEnum.N"
              size="mini"
              type="text"
              @click="onReportSuspectPict(item, index)"
            >
              <span class="btn"> AI纠正 </span>
            </el-button>
            <el-button
              v-if="data.suspectInfo.isReport === isReportEnum.Y"
              size="mini"
              type="text"
              @click="onReportSuspectPictDelete(item, index)"
            >
              <span class="btn">
                {{
                  data.suspectInfo.reportType == ReportTypeEnum.AI ? "取消纠错" : "取消反馈"
                }}
              </span>
            </el-button> -->
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { ReportTypeEnum, isReportMap, isReportEnum } from "../enum";
export default {
  props: ["getList"],
  data() {
    return {
      ReportTypeEnum,
      isReportMap,
      isReportEnum,
      dialogVisible: false,
      loading: false,
      data: {},
    };
  },
  methods: {
    open(data) {
      this.data = data;
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    extractPictFlag(url) {
      const fileName = url.substring(url.lastIndexOf('/') + 1);
      // 找到最后一个点的位置
      const lastDotIndex = fileName.lastIndexOf('.');
      // 从最后一个点往前截取24位
      const startIndex = Math.max(0, lastDotIndex - 24);
      const namePart = fileName.substring(startIndex, lastDotIndex);
      // 去掉下划线
      const finalName = namePart.replace(/_/g, '');
      return finalName;
    },

    async onReportSuspectPict(item, index) {
      const pictFlag = this.extractPictFlag(this.data.imgSrc);
      const query = {
        tenantGuid: this.data.tenantGuid,
        accountMonth: this.data.accountMonth,
        bizGuid: this.data.bizGuid,
        functionCode: this.data.functionCode,
        pictPath: this.data.imgSrc,
        pictFlag,
        suspectTypes: [item.suspectType],
        reportType: ReportTypeEnum.AI, // 弹窗里面的识别错误只有ai 没有人工
        isReport: isReportEnum.Y,
      };
      this.loading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/report-suspect-pict/save`,
        query
      );
      if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        this.data.suspectInfo.afterSuspectType = this.data.suspectInfo.afterSuspectType.map(
          (item, idx) => {
            return {
              ...item,
              isReport: index === idx ? isReportEnum.Y : item.isReport,
            };
          }
        );
      } else {
        this.$message.error(data.msg);
      }
      await this.getList();
      this.loading = false;
    },
    async onReportSuspectPictDelete(item, index) {
      const pictFlag = this.extractPictFlag(this.data.imgSrc);
      // 取消反馈时
      // 有可能人工在弹窗外面审核 在弹窗内部 取消 
      let reportType = ReportTypeEnum.AI;
      if (item.reportType == ReportTypeEnum.MANUAL) {
        reportType = ReportTypeEnum.MANUAL;
      }
      const query = {
        tenantGuid: this.data.tenantGuid,
        accountMonth: this.data.accountMonth,
        bizGuid: this.data.bizGuid,
        functionCode: this.data.functionCode,
        pictPath: this.data.imgSrc,
        pictFlag,
        reportType,
        isReport: isReportEnum.N,
      };
      this.loading = true;
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/report-suspect-pict/delete`,
        query
      );
      if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        this.data.suspectInfo.afterSuspectType = this.data.suspectInfo.afterSuspectType.map(
          (item, idx) => {
            return {
              ...item,
              isReport: index === idx ? isReportEnum.N : item.isReport,
            };
          }
        );
      } else {
        this.$message.error(data.msg);
      }
      await this.getList();
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="less">
.overflow-auto {
  overflow: auto;
}
.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.gap-16 {
  gap: 16px;
}
.text-bage {
  border-radius: 50%;
  width: 18px;
  text-align: center;
}
.p-8 {
  padding: 8px;
}

.btn {
  color: #212121;
  border-bottom: 1px solid #333;
}
</style>
